import { render, staticRenderFns } from "./newDashboardTheme.vue?vue&type=template&id=1228473b"
import script from "./newDashboardTheme.vue?vue&type=script&lang=js"
export * from "./newDashboardTheme.vue?vue&type=script&lang=js"
import style0 from "./newDashboardTheme.vue?vue&type=style&index=0&id=1228473b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports